"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// MIT © 2017 azu
var map_like_1 = require("map-like");
var StoreGroupUtils_1 = require("./StoreGroupUtils");
// ====
// Note: This module doesn't show warning in production
// ====
/**
 * Warning: check immutability state between prevState and nextState.
 * If the store call `Store#emitChange()` and the state of store is not changed, show warning
 * https://github.com/almin/almin/issues/151
 * https://github.com/almin/almin/pull/205
 */
var warningIfChangingStoreIsNotImmutable = function (store, prevState, nextState) {
    // If the store emitChange, check immutability
    var isStateChanged = StoreGroupUtils_1.shouldStateUpdate(store, prevState, nextState);
    if (isStateChanged) {
        return;
    }
    console.error("Warning(Store): " + store.name + " does call emitChange(). \nBut, this store's state is not changed.\nStore's state should be immutable value.\nPrev State:", prevState, "Next State:", nextState);
};
/**
 * Warning: check immutability of the `store`'s state
 * If the store's `state` property is directly modified, show warning message.
 * We recommenced to use `Store#setState` for updating state of store.
 * https://github.com/almin/almin/issues/151
 */
var warningIfStatePropertyIsModifiedDirectly = function (store, prevState, nextState) {
    // If the store return **changed** state, but shouldStateUpdate return false.
    // This checker aim to find updating that is not reflected to UI.
    if (!store.hasOwnProperty("state")) {
        return;
    }
    // store.state is not same with getState value
    // It means `store.state` is not related with getState
    if (store.state !== nextState) {
        return;
    }
    var isStateReferenceReplaced = prevState !== nextState;
    var isStateUpdated = StoreGroupUtils_1.shouldStateUpdate(store, prevState, nextState);
    var isStateReplacedButShouldNotUpdate = isStateReferenceReplaced && !isStateUpdated;
    if (isStateReplacedButShouldNotUpdate) {
        console.error("Warning(Store): " + store.name + "#state property is replaced by different value directly, but this changes **does not** reflect to view.\nBecause, " + store.name + "#shouldStateUpdate(prevState, newState) has returned **false**.\nIt means that you have replaced store's state by new state directly, but it is not correct way.\n\nNG: assign newState to state property directly\n    \n    this.state = newState;\n\nThe mismatch is occurred between " + store.name + "#state property and shouldStateUpdate.\nYou should use `Store#setState` method for updating store's state.\n\nOK: update state via setState\n\n    this.setState(newState);\n    \n    // OR\n\n    // setState alias\n    if(this.shouldStateUpdate(this.state, newState)){\n        this.state = newState;\n    }\n", "prevState", prevState, "nextState", nextState);
    }
};
/**
 * Check the usage of Store#emitChange.
 * If the store call `Store#emitChange()` but the state of store is not changed, show warning.
 * https://github.com/almin/almin/issues/151
 * https://github.com/almin/almin/pull/205
 */
var StoreGroupEmitChangeChecker = /** @class */ (function () {
    function StoreGroupEmitChangeChecker() {
        // store/state cache map for emitChange
        this._emitChangeStateCacheMap = new map_like_1.MapLike();
    }
    /**
     * mark `store` as `emitChange`ed store in a UseCase life-cycle
     *
     * Warning: Show warning message if the `store`'s state is not changed.
     */
    StoreGroupEmitChangeChecker.prototype.mark = function (store, cachedPrevState, nextState) {
        // prevState for emitChange.
        var previousEmitChangedState = this._emitChangeStateCacheMap.get(store);
        var prevState = previousEmitChangedState || cachedPrevState;
        // Check immutability of state
        warningIfChangingStoreIsNotImmutable(store, prevState, nextState);
        this._emitChangeStateCacheMap.set(store, nextState);
    };
    /**
     * Is this `store` marked by the checker?
     */
    StoreGroupEmitChangeChecker.prototype.isMarked = function (store) {
        return this._emitChangeStateCacheMap.has(store);
    };
    /**
     * unMark `store` at end of a useCase life-cycle
     * When the nextState is confirmed, should call it.
     */
    StoreGroupEmitChangeChecker.prototype.unMark = function (store) {
        this._emitChangeStateCacheMap.delete(store);
    };
    /**
     * Warning: Show warning message if the `store`'s state is modified directly.
     * We recommenced to use `Store#setState` for updating state of store.
     *
     * ## Example
     *
     * ```js
     * class MyStore extends Store {
     *  receivePayload(){
     *      // direct modified
     *      this.state = { value: "next" }
     *  }
     * }
     * ```
     */
    StoreGroupEmitChangeChecker.prototype.warningIfStatePropertyIsModifiedDirectly = function (store, prevState, nextState) {
        // TODO: We could not support mixed updating style for store.
        // If `Store#emitChange` and directly update state in `receivePayload` is mixed,
        // we can't validate correctness of the state
        if (!this.isMarked(store)) {
            warningIfStatePropertyIsModifiedDirectly(store, prevState, nextState);
        }
    };
    return StoreGroupEmitChangeChecker;
}());
exports.StoreGroupEmitChangeChecker = StoreGroupEmitChangeChecker;
//# sourceMappingURL=StoreGroupEmitChangeChecker.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UILayer/StoreGroupEmitChangeChecker.js
// module id = 469
// module chunks = 0